import { queryOptions, useQuery } from '@tanstack/react-query';
import { AdaptivePlannerScenarioApi } from '@/lib/api/adaptive-planner/scenario';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getScenarioQueryOptions = ({
  planId,
  scenarioId,
  enabled = true,
}: {
  planId: number;
  scenarioId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.scenarios.detail({
      planId,
      scenarioId,
    }),
    queryFn: () =>
      AdaptivePlannerScenarioApi.getScenario({
        planId,
        scenarioId,
      }),
    enabled,
  });

export const useGetScenarioQuery = ({
  planId,
  scenarioId,
  enabled = true,
}: {
  planId: number;
  scenarioId: number;
  enabled?: boolean;
}) => {
  return useQuery(getScenarioQueryOptions({ planId, scenarioId, enabled }));
};
